module.exports = __webpack_public_path__ + "static/img/hei_fei.d96d2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/hei_fei.png
// module id = eTp+
// module chunks = 2